import { ExtensibilityModeEnum } from 'owa-addins-types';

export interface NavigationState {
    hostItemIndex: string;
    mode: ExtensibilityModeEnum;
}

let navigationState: NavigationState = getInitialNavigationState();

export function getNavigationState(): NavigationState {
    return navigationState;
}

export function setNavigationState(state: NavigationState) {
    navigationState = state;
}

export function resetNavigationState() {
    navigationState = getInitialNavigationState();
}

function getInitialNavigationState(): NavigationState {
    return {
        hostItemIndex: null,
        mode: ExtensibilityModeEnum.Unknown,
    };
}
